import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { EntidadesProductiva } from './entity-entidades-productiva.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityEntidadesProductivaLoadRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Load Request'
);

export const entityEntidadesProductivaLoadFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Load Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaLoadSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Load Success',
  props<{ items: EntidadesProductiva[] }>()
);

// ADD
export const entityEntidadesProductivaAddRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Add Request',
  props<{ item: EntidadesProductiva }>()
);

export const entityEntidadesProductivaAddFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Add Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaAddSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Add Success',
  props<{ item: EntidadesProductiva }>()
);

// CHANGE
export const entityEntidadesProductivaChangeRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Change Request',
  props<{ item: EntidadesProductiva }>()
);

export const entityEntidadesProductivaChangeFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Change Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaChangeSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Change Success',
  props<{ item: EntidadesProductiva }>()
);

// DELETE
export const entityEntidadesProductivaDeleteRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Delete Request',
  props<{ item: EntidadesProductiva }>()
);

export const entityEntidadesProductivaDeleteFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Delete Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaDeleteSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVA] Delete Success',
  props<{ item: EntidadesProductiva }>()
);
